<template>
    <v-card flat outlined tile class="list-side">
        <v-card-title class="list-side__title"> {{ title }} </v-card-title>
        <v-list dense class="pa-0">
            <v-list-item-group v-model="selected" color="primary" @change="setActive">
                <draggable v-model="items" handle=".list-side__handle" draggable=".list-side__item" @input="emit">
                    <template v-for="item in items">
                        <v-list-item :value="item.tempId" class="list-side__item" :key="`${item.tempId}-item`">
                            <v-list-item-icon class="list-side__handle" style="cursor: grab">
                                <v-icon>mdi-drag</v-icon>
                            </v-list-item-icon>

                            <v-list-item-title> {{ item.term }} </v-list-item-title>
                            <v-list-item-action v-if="item.tempId == selected">
                                <v-layout style="gap: 4px" class="mr-4 my-n1">
                                    <v-btn x-small icon text @click="edit" v-if="!mobile">
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn x-small icon text @click="pull">
                                        <v-icon>mdi-trash-can</v-icon>
                                    </v-btn>
                                </v-layout>
                            </v-list-item-action>
                        </v-list-item>
                    </template>
                </draggable>
            </v-list-item-group>
        </v-list>
    </v-card>
</template>

<script>
import { EMPLOYMENT_FIELD_SIDES, EMPLOYMENT_FIELD_TYPES, initEmploymentForm } from "@/assets/variables";

import Draggable from "vuedraggable";
import { mapState } from "vuex";

export default {
    components: {
        Draggable,
    },
    props: {
        /** @type {import('vue/types/options').DataDef<import('@/assets/variables').EmploymentForm>} */
        value: { type: Object, default: initEmploymentForm },

        side: { type: String, default: EMPLOYMENT_FIELD_SIDES.DOCUMENT.value },
        mobile: { type: Boolean, default: false },
    },
    data: () => ({
        form: initEmploymentForm(),
        items: [],

        selected: null,
    }),
    computed: {
        ...mapState("employment/form/node", ["active"]),
        title() {
            return EMPLOYMENT_FIELD_SIDES[this.side].text;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
        active(active) {
            this.selected = active?.tempId || null;
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentForm(this.value);
            this.items = this.form.fields.filter(({ side, type }) => side == this.side && type != EMPLOYMENT_FIELD_TYPES.FILE.value);
            this.selected = this.active?.tempId || null;
        },
        emit() {
            this.form.fields = [...this.form.fields.filter(({ side, type }) => side != this.side || type == EMPLOYMENT_FIELD_TYPES.FILE.value), ...this.items];
            this.$emit("input", this.form);
        },
        edit() {
            this.$store.commit("employment/form/node/setIsEdit", true);
        },
        pull() {
            this.$store.dispatch("employment/form/node/pullItem", { tempId: this.selected });
        },
        setActive(value) {
            let item = this.items.find(({ tempId }) => tempId == value);
            this.$store.commit("employment/form/node/setIsEdit", false);
            this.$store.commit("employment/form/node/setActive", item);
        },
    },
};
</script>

<style lang="scss" scoped>
.list-side {
    &__title {
        font-size: 14px;
        height: 60px;
    }
    &__item {
        display: flex;
        flex-direction: row;
        align-items: center;
        border-top: 1px solid rgba(0, 0, 0, .12);
    }
}
</style>
